/** The limits a projected value is checked against: the player's saved limits (none until saved) and the regulator's minimums. One source for Decide's preview and the event cards' facts. */
import type { ContentCatalog, TeamState } from "@bsim/contracts";
import { limitFor, limitsSaved } from "../cockpit/derive";
import { floorLabelOf, regulatoryMinimumOf } from "../chair/limits";
import type { PreviewLimits } from "./previewRows";

export const limitsOf = (team: TeamState, catalog: ContentCatalog): PreviewLimits => ({
  own: (kpi) => (limitsSaved(team) ? limitFor(team, kpi) : null),
  usual: (kpi) => { const d = catalog.riskAppetiteDefaults.find((l) => l.kpi === kpi); return d === undefined ? null : { limit: d.limit, cmp: d.cmp }; },
  regulatoryMinimum: (kpi) => regulatoryMinimumOf(kpi, catalog),
  fixed: (kpi) => { const f = catalog.riskAppetiteFixed?.find((l) => l.kpi === kpi); return f === undefined ? null : { limit: f.limit, cmp: f.cmp }; },
  floorLabel: (kpi) => floorLabelOf(kpi, catalog),
});
